import { _nullishCoalesce, _optionalChain } from '@sentry/utils';
import { GLOBAL_OBJ } from '@sentry/utils';

/**
 * Function that delays closing of a Vercel lambda until the provided promise is resolved.
 *
 * Vendored from https://www.npmjs.com/package/@vercel/functions
 */
function vercelWaitUntil(task) {
  const vercelRequestContextGlobal =
    // @ts-expect-error This is not typed
    GLOBAL_OBJ[Symbol.for('@vercel/request-context')];

  const ctx = _nullishCoalesce(_optionalChain([vercelRequestContextGlobal, 'optionalAccess', _ => _.get, 'optionalCall', _2 => _2()]), () => ( {}));
  _optionalChain([ctx, 'access', _3 => _3.waitUntil, 'optionalCall', _4 => _4(task)]);
}

export { vercelWaitUntil };
//# sourceMappingURL=vercelWaitUntil.js.map
